export enum PlaceholderId {
  FirstName = '[first_name]',
  LastName = '[last_name]',
  Candidate = '[candidate]',
  Recruiter = '[recruiter]',
  EmailSender = '[email_sender]',
  RecruiterPerJob = '[recruiter_per_job]',
  HiringManager = '[hiring_manager]',
  JobOffer = '[job_offer]',
  Company = '[company]',
  Department = '[department]',
  EventTitle = '[event_title]',

  CandidateFirst = '[candidate.first]',
  CandidateLast = '[candidate.last]',
  CandidateFull = '[candidate.full]',
  CandidateFullEmail = '[candidate.full_email]',
  CandidateGeneralTitle = '[candidate.general_title]',
  CandidateProfessionalTitle = '[candidate.professional_title]',

  FormalGreetingTitlesLast = '[formal_greeting.titles_last]',

  JobOfferAll = '[job_offer.all]',

  RecruiterPerJobFirst = '[recruiter_per_job.first]',
  RecruiterPerJobLast = '[recruiter_per_job.last]',
  RecruiterPerJobFull = '[recruiter_per_job.full]',
  RecruiterPerJobFullEmail = '[recruiter_per_job.full_email]',

  HiringManagerFirst = '[hiring_manager.first]',
  HiringManagerLast = '[hiring_manager.last]',
  HiringManagerFull = '[hiring_manager.full]',
  HiringManagerFullEmail = '[hiring_manager.full_email]',

  EventFull = '[event.full]',
  EventLink = '[event.link]',
  EventLocation = '[event.location]',
  EventDate = '[event.date]',
  EventType = '[event.type]',
  EventInterviewers = '[event.interviewers]',
  EventName = '[event.name]',

  EmailSenderFirst = '[email_sender.first]',
  EmailSenderLast = '[email_sender.last]',
  EmailSenderFull = '[email_sender.full]',
  EmailSenderFullEmail = '[email_sender.full_email]',
}

export enum PlaceholderCategory {
  Candidate = 'candidate',
  EmailSender = 'email_sender',
  Event = 'event',
  HiringManager = 'hiring_manager',
  Recruiter = 'recruiter_per_job',
  FormalGreetingsAndTitles = 'formal_greetings_and_titles',
}

export type PlaceholderStatus = { invalid: boolean; message: string } | null;
export type PlaceholderData = {
  value: string | null;
  description?: string | null;
  status?: PlaceholderStatus;
};
export type PlaceholderConfig = { disabled?: boolean; overrideTooltipText?: string };
export type PlaceholderConfigMap = Record<string, PlaceholderConfig>;

export class Placeholder {
  public readonly interpolated: boolean;
  public readonly value: string;

  constructor(
    public readonly id: PlaceholderId | 'empty',
    public readonly data: PlaceholderData,
  ) {
    this.value = this.data.value || this.id;
    this.interpolated = this.id !== this.value;
  }

  public toString(): string {
    return this.id;
  }

  public clone(data: { description: string; value: string }): Placeholder {
    return new Placeholder(this.id, { ...this.data, ...data });
  }
}
